import React from "react";
import PropTypes from "prop-types";
import ButtonGroup from "../ButtonGroup";
import dictionary from "../../../dictionary";

import styles from "./button-group.module.scss";

function ChocolateType(props) {
  const {name, content, onChange, current} = props;
  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        renderButton={({value, difference}) => (
          <span className={styles.value}>
            {dictionary.item[value]}
            {` `}
            {value !== current && difference && (
              <span className={styles.difference}>{difference}₽</span>
            )}
          </span>
        )}
      />
      <span className={styles.label}>– шоколад в наличии</span>
    </div>
  );
}

ChocolateType.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.string
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default ChocolateType;
